export type BreakpointKey = 'sm' | 'md' | 'lg' | 'xl' | 'xxl';

const DEFAULT_BREAKPOINTS: Record<BreakpointKey, number> = {
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200,
  xxl: 1400,
};

export const breakpointPx = (bp: BreakpointKey): number => {
  const value =
    typeof document === 'undefined'
      ? ''
      : getComputedStyle(document.documentElement).getPropertyValue(
          `--bs-breakpoint-${bp}`
        );
  const px = parseFloat(value);

  return Number.isFinite(px) ? px : DEFAULT_BREAKPOINTS[bp];
};

const FALLBACK_MQL: MediaQueryList = {
  matches: false,
  media: '',
  onchange: null,
  addEventListener: () => {},
  removeEventListener: () => {},
  addListener: () => {},
  removeListener: () => {},
  dispatchEvent: () => false,
};

const canMatchMedia =
  typeof window !== 'undefined' && typeof window.matchMedia === 'function';

export const matchBelow = (bp: BreakpointKey) =>
  canMatchMedia
    ? window.matchMedia(`(max-width: ${breakpointPx(bp) - 0.02}px)`)
    : FALLBACK_MQL;

export const matchAbove = (bp: BreakpointKey) =>
  canMatchMedia
    ? window.matchMedia(`(min-width: ${breakpointPx(bp)}px)`)
    : FALLBACK_MQL;
